import { isValidPhoneNumber } from 'libphonenumber-js';
import { useTranslation } from 'next-i18next';
import * as yup from 'yup';

import { IAuth } from '../../../types';

export const useResetPasswordHook = () => {
  const { t } = useTranslation();

  const ForgotPasswordFormValidationSchema: yup.SchemaOf<IAuth.IForgotPasswordSchema> =
    yup.object().shape({
      phoneNumber: yup
        .string()
        .test('phoneNumber', t('number_incorrect_try_again'), function (value) {
          const email = this.parent.email;
          if (email && email.length > 0) {
            return true; // Skip phone number validation if email is provided
          }
          return value ? isValidPhoneNumber(value, 'EG') : false;
        })
        .when('email', (email, schema) =>
          !email ? schema.nullable() : schema
        ),
      country: yup.string(),

      email: yup.string().email(t('invalid-email')),
    });

  const ResetPasswordFormValidationSchema: yup.SchemaOf<IAuth.IResetPasswordSchema> =
    yup.object().shape({
      password: yup
        .string()
        .required(t('this-field-is-required'))
        .test(
          'password-strength',
          t('password-must-match-requirements'),
          function (value) {
            if (!value) {
              return false;
            }
            const hasMinLength = value?.length >= 8;
            const hasNumber = /\d/.test(value || '');
            const hasLetter = /[a-zA-Z]/.test(value || '');

            return hasMinLength && hasNumber && hasLetter;
          }
        ),
      confirmPassword: yup
        .string()
        .required(t('this-field-is-required'))
        .oneOf([yup.ref('password')], t('passwords-must-match')),
    });

  return {
    ResetPasswordFormValidationSchema,
    ForgotPasswordFormValidationSchema,
  };
};
